import {LIVE_FX, AUDIO_FX} from 'constants/effect-types.js';

export const getEffectTrack = (e) => {
    if (e && e.getEffectType && e.getEffectType() !== AUDIO_FX && e.track) {
        return e.track;
    }
    if (e.context) {
        return e.context.track;
    }
    return e.track;
};
